/**
 * Flow Custom JS
 */
/* eslint-disable */

 (function flowCustom() {
  const config = {
    cls: {
      add: 'js-flow-add',
      remove: 'js-flow-remove',
      product_meta: 'js-product-meta',
      go_to_checkout: 'js-go-to-checkout',
      menu_trigger: 'js-dropdown-trigger',
      mobile_menu_triger: 'js-show-sublinks',
      hidden_section_world: '[data-hide-section="world"]',
      hidden_section_us: '[data-hide-section="us"]',
    }
  };

  SDG.FlowAttachEvents = attachFlowEvents;
  SDG.FlowRemove = flowRemove;
  SDG.FlowLocalizeAll = flowLocalizeAll;
  SDG.FlowRedirectToCheckout = redirectToCheckout;
  SDG.FlowCollectionPrices = flowCollectionPrices;

  const {
    isEuStore,
    usStoreDomain,
    hkStoreDomain,
  } = window.theme;
  let hasAdjustedCountryOrder = false;

  /**
   * Init
   */
  function init() {
    Flow.set('on', 'ready', function () {
      const $addToCartButtons = document.querySelectorAll(`.${config.cls.add}`);
      const $productMeta = document.querySelector(`.${config.cls.product_meta}`);
      const currentCountry = Flow.session.getSession().geo.locale.country;
      if ($addToCartButtons && $productMeta) {
        $addToCartButtons.forEach(($button) => $button.addEventListener('click', flowAdd));
      }

      storefrontRedirect(currentCountry)
      flowLocalizeAll();
      hideSaleDropdown();

      const countryPickerOpts = {
        type: 'modal',
        logo: false,
        containerId: 'countryPicker',
        modalTitle: 'Select an Experience',
        displayDefaultCurrency: false,
      };

      countryPickerOpts.onSelection = handleStorefrontRedirect;
      window.flow.countryPicker.createCountryPicker(countryPickerOpts);

      // Give time for country picker to init
      setTimeout(() => {
        const $countryPickerModalTrigger = document.querySelector('.flow-country-picker-modal-trigger');
        if ($countryPickerModalTrigger) {
          $countryPickerModalTrigger.addEventListener('click', moveCountryOptions);
        }
      }, 750);

      // Remove elments that shouldn't be displayed to international users
      const queryIdentifier = Flow.getExperience()
        ? config.cls.hidden_section_world
        : config.cls.hidden_section_us;

      const $elsToHide = document.querySelectorAll(queryIdentifier);
      $elsToHide.forEach(($el) => $el.remove());
    });

    document.addEventListener('cart:refresh:end', () => {
      if (Flow.getExperience()) {
        SDG.FlowAttachEvents();
      }
    });
  }

  /**
   * Flow Localize All
   */
  function flowLocalizeAll() {
    if (Flow && Flow.getExperience()) {
      Flow.localize({force: true});
      Flow.variants.localize({force: true});
      Flow.cart.localize({force: true});
      updateComparePrices();
    }
  }

  /**
   * Attach Flow Events
   */
  function attachFlowEvents() {
    const $checkoutButtons = document.querySelectorAll(`.${config.cls.go_to_checkout}`);
    $checkoutButtons.forEach(($button) => $button.addEventListener('click', redirectToCheckout));
  }

  /**
   * Flow Collection Prices
   */
  function flowCollectionPrices(products) {

    for (const id in products) {
      const $flowProductPrice = document.querySelector(`.js-flow-price[data-product-handle="${products[id].handle}"]`);
      const $flowRegularPrice = $flowProductPrice.querySelector('.js-flow-regular-price');
      const $flowComparePrice = $flowProductPrice.querySelector('.js-flow-compare-price');

      if (products[id].prices.compare_at) {
        $flowRegularPrice.classList.add('is-sale');
        if ($flowComparePrice) $flowComparePrice.classList.remove('is-hidden');
      } else {
        $flowRegularPrice.classList.remove('is-sale');
        if ($flowComparePrice) $flowComparePrice.classList.add('is-hidden');
      }
    }

  }

  /**
   * Flow Add
   */
  function flowAdd() {
    const $productMeta = document.querySelector(`.${config.cls.product_meta}`);

    const { price, variantId } = $productMeta.dataset;
    const params = {
      item_number: variantId,
      price: {
        amount: price,
        currency: 'USD'
      },
      quantity: 1
    };

    if (Flow) {
      Flow.beacon.processEvent('cart_add', params, { xhr: true });
    }
  }

  /**
   * Flow Remove
   */
  function flowRemove(e) {
    const $target = e.target;
    const variantId = $target.dataset.variantId;
    const params = {
      item_number: variantId
    };

    if (Flow) {
      Flow.beacon.processEvent('cart_remove', params, { xhr: true });
    }
  }

  /**
   * Redirect to checkout
   */
  function redirectToCheckout(e) {
    // if (Flow.getExperience()) {
    //   e.preventDefault();
    //   Flow.checkout.redirect();
    // }
  }

  /**
   * Handle Storefront Redirect
   * @param {Object} country
   */
  function handleStorefrontRedirect(country) {
    window.location.href = `${usStoreDomain}?flow_country=${country.iso_3166_3}`;
  }

  /**
   * Storefront Redirect
   * @param {string} country
   */
  function storefrontRedirect(country) {
    const isShopifyAdminPanel = window.location.origin.includes('myshopify.com');

    if (!country || isShopifyAdminPanel) return;

    const EUCountries = ['AUT', 'BEL', 'BGR', 'HRV', 'CYP', 'CZE', 'DNK', 'EST', 'FIN',
                        'FRA', 'DEU', 'GRC', 'HUN', 'IRL', 'ITA', 'LVA', 'LTU', 'LUX', 'MLT',
                        'NLD', 'POL', 'PRT', 'ROU', 'SVK', 'SVN', 'ESP', 'SWE'];

    const isEUCountry = EUCountries.includes(country);
    const EUStoreFront = 'https://europe.dvf.com/';

    const HKCountries = ['MAC', 'HKG']
    const isHKCountry = HKCountries.includes(country);

    const currentStorefront = window.location.host;

    if (isEUCountry && !EUStoreFront.includes(currentStorefront)) window.location.href = EUStoreFront;
    if (isHKCountry && hkStoreDomain !== '' && !hkStoreDomain.includes(currentStorefront)) window.location.href = hkStoreDomain;
  }

  /**
   * Hide Sale Dropdown
   */
  function hideSaleDropdown() {
    const experience = Flow.getExperience();
    const queryIdentifier = experience ? '[data-sale-menu="us"]' : '[data-sale-menu="world"]';
    const $navItemsToRemove = document.querySelectorAll(queryIdentifier);
    $navItemsToRemove.forEach(($navItem) => $navItem.remove());
  }

  /**
   * Move Country Options
   */
  function moveCountryOptions() {
    if (hasAdjustedCountryOrder) return; // Return out if we've already moved the options

    // Give time for country picker menu to initialize
    setTimeout(() => {
      const $countryModal = document.querySelector('.flow-country-picker-modal');
      if ($countryModal) {
        const $countryModalBody = $countryModal.querySelector('.flow-country-picker-modal-body-content');
        const $europeanUnion = document.createElement('DIV');
        const $unitedKindom = document.createElement('DIV');
        const $hongKong = document.createElement('DIV');
        const $macau = document.createElement('DIV');

        $europeanUnion.classList = 'flow-country-picker-modal-item-container';
        $unitedKindom.classList = 'flow-country-picker-modal-item-container';
        $hongKong.classList = 'flow-country-picker-modal-item-container';
        $macau.classList = 'flow-country-picker-modal-item-container';
        $europeanUnion.innerHTML = `
                          <a href="https://europe.dvf.com" class="flow-country-picker-modal-item">
                            <span class="flow-country-picker-modal-text">European Union Countries</span>
                          </a>`;
        $unitedKindom.innerHTML = `
                          <a href="https://uk.dvf.com" class="flow-country-picker-modal-item">
                            <span class="flow-country-picker-modal-text">United Kingdom</span>
                          </a>`;
        $hongKong.innerHTML = `
                          <a href="${hkStoreDomain}" class="flow-country-picker-modal-item">
                            <span class="flow-country-picker-modal-text">Hong Kong</span>
                          </a>`;
        $macau.innerHTML = `
                          <a href="${hkStoreDomain}" class="flow-country-picker-modal-item">
                            <span class="flow-country-picker-modal-text">Macau</span>
                          </a>`;

        [...$countryModalBody.children].forEach(($child) => {
          const isCorrectCountry = $child.innerHTML.includes('United States of America');
          const isUK = $child.innerHTML.includes('United Kingdom');
          const isHongKong = $child.innerHTML.includes('Hong Kong')
          const isMacau = $child.innerHTML.includes('Macau');

          if (isCorrectCountry) {
            $countryModalBody.insertBefore($child, $countryModalBody.children[0]);
            $countryModalBody.insertBefore($unitedKindom, $countryModalBody.children[1]);
            $countryModalBody.insertBefore($europeanUnion, $countryModalBody.children[2]);
            $countryModalBody.insertBefore($hongKong, $countryModalBody.children[3]);
          }

          if(isHongKong && hkStoreDomain !== '') {
            $child.innerHTML = $hongKong.innerHTML;
          }
          if(isMacau && hkStoreDomain !== '') {
            $child.innerHTML = $macau.innerHTML;
          };

          if (isUK) $child.remove();
        });
        hasAdjustedCountryOrder = true;
      } else {
        moveCountryOptions(); // call self if modal doesn't exist yet.
      }
    }, 500);
  }

  /**
   * Update Compare Prices
   */
  function updateComparePrices() {
    const $comparePrices = document.querySelectorAll('[data-shopify-compare-at]');
    $comparePrices.forEach(($price) => {
      const { shopifyCompareAt } = $price.dataset;
      const samePrice = shopifyCompareAt === $price.innerHTML;
      if (samePrice) {
        const foundParents = window.parents($price, '.ProductItem');
        const [$productItem] = foundParents || [];
        if ($productItem) {
          const $saleLabel = $productItem.querySelector('.ProductItem__Label--onSale');
          if ($saleLabel) $saleLabel.remove();
        }
        $price.remove(); // Remove the price if it's not changed by Flow
      }
    });
  }

  return init();
})();
